import styles from "./Header.module.scss";
import DottedPill from "@components/templates/Profile/ProfileHeader/DottedPill";
import { useEffect, useState } from "react";
import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import { profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { toast } from "react-toastify";
import axios from "axios";
import { apiEndPoints, profileCategory } from "@containers/TradeLanesProfile/utils/enum";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { profileRedirectionIdHandler } from "@redux/TradeLanesProfile/tradeLanesProfileSlice";
import NoSearchDataComponent from "@shared/country-components/no-search-data";
import { transformPillData } from "@containers/TradeLanesProfile/utils/helpers";

const Header = () => {
  const { tradeLaneId, tradeLaneName } = useParams();
  const [error, setError] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [headerData, setHeaderData] = useState(null);
  const [pillData, setPillData] = useState([]);

  useEffect(() => {
    const fetchHeaderDetails = async () => {
      try {
        const requestPayload = {
          profile_type: profileTypeEnum.tradeLanes,
          _id: tradeLaneId,
          slug: tradeLaneName,
          category: profileCategory,
        };
        const res = await axios.post(apiEndPoints.getProfileHeaderDetails, requestPayload);
        const { data } = res.data;
        if (data) {
          setHeaderData(data);
          const { lading_region_acronym, lading_trade_data_mapping, unlading_region_acronym, unlading_trade_data_mapping } = data;
          setPillData(transformPillData(lading_region_acronym, lading_trade_data_mapping, unlading_region_acronym, unlading_trade_data_mapping));

          const { elastic_data_id } = data;
          dispatch(profileRedirectionIdHandler(elastic_data_id?.[0]));
        } else {
          throw new Error("");
        }
      } catch (err) {
        setError(true);
        toast.error("Something went wrong. Please try again later !!!");
      } finally {
        setLoading(false);
      }
    };

    fetchHeaderDetails();
  }, [dispatch, tradeLaneId]);

  return (
    <div className={styles.headerContainer}>
      {loading ? (
        <LoadingSkeleton lines={2} lineHeight="25px" width="50%" shape="rectangle" margin={"1rem 0"} />
      ) : error ? (
        <NoSearchDataComponent className={styles.noSearchDataContainer} content={"Unable to fetch the data at current moment."} />
      ) : (
        <div className="d-flex justify-content-between">
          <div>
            <p className={styles.heading}>
              <span className={styles.tradeLaneHeadingText}>Trade lane: </span> {headerData?.lading_region_acronym} <span className={styles.portLocation}>({headerData?.lading_region})</span>
              <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1711004021/intel/icons/trade_lane_arrow_orrdbf.svg`} />
              {headerData?.unlading_region_acronym} <span className={styles.portLocation}>({headerData?.unlading_region})</span>
            </p>
            <div className={styles.pillContainer}>
              <span className={styles.infoPill}>Baltic Exchange</span>
              {pillData.map(({ value, id, ports, profileType }) => (
                <DottedPill key={id} value={value} backgroundColor="#f1ecfe" textColor="#5a1ce2" borderColor="#5a1ce2" borderWidth="0.5px" dropdownItems={ports} id={id} showDropdown={showDropdown} setShowDropdown={setShowDropdown} profileType={profileType} />
              ))}
            </div>
          </div>
          {/* <div className="d-flex my-2">
            <Notes
              count={profileDetails.notes_count}
              id={profileDetails.favourite_id}
              profileDetails={{
                company_name: profileDetails.trade_lane_name,
                elastic_data_id: profileDetails?.elastic_data_id ?? "",
                company_country: country,
                trade_direction: "import",
                data_source: "multicountry",
              }}
              profileType={profileType.tradeLanes}
              type={"import"}
              tradeDirection={"import"}
              country={country}
              dataSource={"multicountry"}
              comingFrom="company"
              setIsFavourite={setIsFavourite}
            />
            <div>
              <Button className="mx-2" variant={"primaryLightWithIcon"} size={"large"} onClick={() => addToProspect()}>
                {isFavourite ? <img className="bookmarked_icon" src={StarKidFill} width={20} height={20} /> : <span className="material-symbols-outlined">kid_star</span>}
                <span className="ml-1">{isFavourite ? "Bookmarked" : "Bookmark"}</span>
              </Button>
            </div>
          </div> */}
        </div>
      )}
      {/* {showFavModal ? <AddFavModal id={profileDetails?.elastic_data_id?.[0]} profileType={profileType.tradeLanes} show={showFavModal} handleClose={() => setShowFavModal(false)} prospectData={prospectData} type={"import"} tradeDirection={"import"} country={country} dataSource={"multicountry"} setIsFavourite={setIsFavourite} /> : <></>} */}
    </div>
  );
};

export default Header;
